
import React from 'react';
import { Navigate } from "react-router-dom";
import MasterLayout from "../../pages/layouts/MasterLayout";
 
const ProtectedRoutes = ({auth}) => {  
    return (auth === true ? <MasterLayout /> : <Navigate to="/login" replace/>)
}
export default ProtectedRoutes;
